import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Home from '../components/layout/Home/Home'
import Inicio from '../components/layout/Home/Inicio'
import Login from '../components/layout/Login/Login'
import ListadoUsuarios from '../components/layout/Login/ListadoUsuarios'
import ListadoUsuariosAdmin from '../components/layout/Login/ListadoUsuariosAdmin'
import Logout from '../components/layout/Login/Logout'
import AuthContextProvider from "./contexts/AuthContext.js";
import { ChatContextProvider } from "./contexts/ChatContext.js";
import ChatWidget from "./ChatWidget";
import ProviderLogin from './layout/Login/ProviderLogin';
import ProviderDashboard from './views/Providers/ProviderDashboard';
import ProviderRoute from './ProviderRoute';

// {/* Catalogos */}
import BotonesCatalogos from "./views/Catalogos/BotonesCatalogos"
import ListadoAreas from './views/Catalogos/Areas/ListadoAreas'
import ListadoPaqueterias from './views/Catalogos/Paqueterias/ListadoPaqueterias'
import ListadoProveedores from './views/Catalogos/Proveedores/ListadoProveedores'
import ProveedoresCreate from './views/Catalogos/Proveedores/ProveedoresCreate'
import ListadoCiclos from './views/Catalogos/Ciclos/ListadoCiclos'
import ListadoCajas from './views/Catalogos/Cajas/ListadoCajas'
import ListadoPeriodosAdmin from './views/Catalogos/PeriodosAdmin/ListadoPeriodosAdmin'
import PeriodosAdminCreate from './views/Catalogos/PeriodosAdmin/PeriodosAdminCreate'
import ListadoDepartamentos from './views/Catalogos/Departamentos/ListadoDepartamentos'
import ListadoGrupos from './views/Catalogos/Grupos/ListadoGrupos'

// {/* Articulos */}
import BotonesArticulos from "./views/Articulos/BotonesArticulos"
import ListadoLineas from './views/Articulos/Lineas/ListadoLineas'
import ListadoColores from './views/Articulos/Colores/ListadoColores'
import ListadoTallas from "./views/Articulos/Tallas/ListadoTallas.jsx";
import ListadoMarcas from './views/Articulos/Marcas/ListadoMarcas'
import ListadoFamilias from './views/Articulos/Familias/ListadoFamilias'
import ListadoColecciones from './views/Articulos/Colecciones/ListadoColecciones'
import ListadoArticulos from './views/Articulos/Articulos/ListadoArticulos'
import ListadoArticulosFoto from './views/Articulos/Articulos/ListadoArticulosFoto'
import ArticulosCreate from './views/Articulos/Articulos/ArticulosCreate'
import ListadoPreArticulos from "./views/Articulos/PreArticulos/ListadoPreArticulos.jsx";
import PreArticulosCreate from "./views/Articulos/PreArticulos/PreArticulosCreate.jsx";
import ConvertirArticulos from "./views/Articulos/PreArticulos/ConvertirArticulo.jsx";
import GeneradorEtiquetas from "./views/Articulos/Articulos/GeneradorEtiquetas.jsx";
import ListadoPreArticulosChina from "./views/Articulos/PreArticulosChina/ListadoPreArticulosChina.jsx";
import PreArticulosChinaCreate from "./views/Articulos/PreArticulosChina/PreArticulosChinaCreate.jsx";
import GeneradorEtiquetasChina from "./views/Articulos/PreArticulosChina/GeneradorEtiquetasChina.jsx";

// {/* Inventarios */}
import BotonesInventarios from "./views/Inventarios/BotonesInventarios"
import ListadoInventarios from './views/Inventarios/Inventarios/ListadoInventarios'
import ListadoDisponible from "./views/Inventarios/Inventarios/ListadoDisponible";
import ListadoKardex from "./views/Inventarios/Inventarios/ListadoKardex";
import ListadoTracking from "./views/Inventarios/Inventarios/ListadoTracking";
import ListadoDisponibleVendedor from "./views/Inventarios/Inventarios/ListadoDisponibleVendedor";
import ListadoInventarioPendRecibir from "./views/Inventarios/Inventarios/ListadoInventarioPendRecibir";
import ListadoAjustesInventario from "./views/Inventarios/Ajustes/ListadoAjustesInventario"
import AjustesInventarioCreate from "./views/Inventarios/Ajustes/AjustesInventarioCreate"
import BotonesTraspasos from "./views/Inventarios/BotonesTraspasos"
import CuadrarInventario from "./views/Inventarios/Inventarios/CuadrarInventario";

// Tiendas
import BotonesTiendas from "./views/Tiendas/BotonesTiendas"
import ListadoInventariosTiendas from './views/Tiendas/ListadoInventariosTiendas'
import ListadoVentasTiendas from './views/Tiendas/VentasTiendas/ListadoVentasTiendas'
import VentasTiendasCreate from './views/Tiendas/VentasTiendas/VentasTiendasCreate'
import ListadoApartadosTiendas from "./views/Tiendas/ApartadosTiendas/ListadoApartadosTiendas";
import ApartadosTiendasCreate from './views/Tiendas/ApartadosTiendas/ApartadosTiendasCreate'
import AbonosTiendasCreate from './views/Tiendas/AbonosTiendas/AbonosTiendasCreate'
import ListadoAbonosTiendas from './views/Tiendas/AbonosTiendas/ListadoAbonosTiendas'
import ListadoGastosTiendas from './views/Tiendas/GastosTiendas/ListadoGastosTiendas'
import GastosTiendasCreate from './views/Tiendas/GastosTiendas/GastosTiendasCreate'
import ListadoDinerosTiendas from "./views/Tiendas/DinerosTiendas/ListadoDinerosTiendas";
import DinerosTiendasCreate from "./views/Tiendas/DinerosTiendas/DinerosTiendasCreate";
import ListadoDevolucionesTiendas from './views/Tiendas/DevolucionesTiendas/ListadoDevolucionesTiendas'
import DevolucionesTiendasCreate from './views/Tiendas/DevolucionesTiendas/DevolucionesTiendasCreate'
import CorteTiendas from "./views/Tiendas/CorteTiendas/CorteTiendas";
import CorteTiendasK from "./views/Tiendas/CorteTiendas/CorteTiendasK";
import EntregarNota from "./views/Tiendas/VentasTiendas/EntregarNota";
import EstadoCuentaTiendas from "./views/Tiendas/EstadoCuentaTiendas/EstadoCuentaTiendas";
import EstadoCuentaTiendasAnalisis from "./views/Tiendas/EstadoCuentaTiendas/EstadoCuentaTiendasAnalisis";
import ListadoVentasTiendasPendientes from "./views/Tiendas/VentasTiendas/ListadoVentasTiendasPendientes";
import ListadoDevolucionesTiendasAdmin from "./views/Tiendas/DevolucionesTiendas/ListadoDevolucionesTiendasAdmin";
import ListadoClientesTiendas from "./views/Tiendas/ClientesTiendas/ListadoClientesTiendas";
import ClientesCreateTiendas from "./views/Tiendas/ClientesTiendas/ClientesCreateTiendas";
import FacturasTiendasCreate from "./views/Tiendas/VentasTiendas/FacturasTiendasCreate.jsx";
import Escaneos from "./views/Tiendas/EscaneosTiendas/EscaneosTiendas";
import ListadoEscaneos from "./views/Tiendas/EscaneosTiendas/ListadoEscaneos";

// Traspasos
import TraspasosSalidaCreate from './views/Inventarios/Traspasos/TraspasosSalidaCreate'
import ListadoTraspasosSalida from './views/Inventarios/Traspasos/ListadoTraspasosSalida'
import TraspasosEntradaCreate from './views/Inventarios/Traspasos/TraspasosEntradaCreate'
import ListadoTraspasosEntrada from './views/Inventarios/Traspasos/ListadoTraspasosEntrada'



// {/* Compras */}
import BotonesCompras from "./views/Compras/BotonesCompras"
import ListadoOrdenesCompra from './views/Compras/OrdenesCompra/ListadoOrdenesCompra'
import OrdenesCompraCreate from './views/Compras/OrdenesCompra/OrdenesCompraCreate'
import ListadoEmbarques from './views/Compras/Embarques/ListadoEmbarques'
import EmbarquesCreate from './views/Compras/Embarques/EmbarquesCreate'
import ListadoPendEmbarcar from "./views/Compras/Embarques/ListadoPendEmbarcar";
import ListadoCompras from "./views/Compras/Compras/ListadoCompras";
import ComprasCreate from "./views/Compras/Compras/ComprasCreate";
import EntradasPreModelos from "./views/Compras/Compras/EntradasPreModelos";
import ListadoPendRecibir from "./views/Compras/Compras/ListadoPendRecibir";
import ListadoConceptosGastosEmbarques from "./views/Compras/ConceptosGastosEmbarques/ListadoConceptosGastosEmbarques";
import ListadoControlCalidad from "./views/Compras/Compras/ListadoControlCalidad";

// {/* Ventas */}
import BotonesVentas from "./views/Ventas/BotonesVentas"
import ListadoPedidos from './views/Ventas/Pedidos/ListadoPedidos'
import VistaPedido from "./views/Ventas/Pedidos/VistaPedido.jsx";
import PedidosCreate from './views/Ventas/Pedidos/PedidosCreate'
import ListadoSurtidos from './views/Ventas/Surtidos/ListadoSurtidos'
import ListadoPendienteSurtir from './views/Ventas/Surtidos/ListadoPendienteSurtir'
import ListadoDevoluciones from './views/Ventas/Devoluciones/ListadoDevoluciones'
import DevolucionesCreate from './views/Ventas/Devoluciones/DevolucionesCreate'
import ListadoDepartamentosClientes from './views/Ventas/DepartamentosClientes/ListadoDepartamentosClientes'
import AnalisisArticulosPedidos from "./views/Ventas/Pedidos/AnalisisArticulosPedidos";
import ListoSurtir from "./views/Ventas/Pedidos/ListoSurtir";
import ListoSurtirCliente from "./views/Ventas/Pedidos/ListoSurtirCliente";

// {/* Gastos */}
import BotonesGastos from "./views/ConfigAdmin/BotonesGastos"
import ListadoPresupuestos from './views/ConfigAdmin/Presupuestos/ListadoPresupuestos'
import PresupuestosCreate from './views/ConfigAdmin/Presupuestos/PresupuestosCreate'
import ListadoGastos from './views/ConfigAdmin/Gastos/ListadoGastos'
import GastosCreate from './views/ConfigAdmin/Gastos/GastosCreate'


import ListadoGastosGeneral from './views/ConfigAdmin/GastosGeneral/ListadoGastosGeneral'
import GastosGeneralCreate from './views/ConfigAdmin/GastosGeneral/GastosGeneralCreate'
import ListadoConceptosGastos from './views/ConfigAdmin/ConceptosGastos/ListadoConceptosGastos'
import ConceptosGastosCreate from './views/ConfigAdmin/ConceptosGastos/ConceptosGastosCreate'


//Nominas
import BotonesNominas from './views/Empleados/BotonesNominas'
import ListadoNominas from "./views/Empleados/Nominas/ListadoNominas"
import ListadoColaboradores from "./views/Empleados/Colaboradores/ListadoColaboradores"
import ListadoFaltasColaboradores from './views/Empleados/Faltas/ListadoFaltasColaboradores'
import FaltasColaboradoresCreate from './views/Empleados/Faltas/FaltasColaboradoresCreate'
import ListadoPuestos from "./views/Empleados/Puestos/ListadoPuestos"
import NominasCreate from "./views/Empleados/Nominas/NominasCreate"
import ColaboradoresCreate from "./views/Empleados/Colaboradores/ColaboradoresCreate"

// Clientes
import ListadoClientes from "./views/Clientes/Clientes/ListadoClientes"
import ClientesCreate from "./views/Clientes/Clientes/ClientesCreate"


//Reportes
import BotonesReportes from './views/Reportes/BotonesReportes'
import BotonesReportesV2 from './views/Reportes/BotonesReportesV2'
import GraficaVentasMensual from "./views/Reportes/GraficaVentasMensual";
import GraficaVentasMensualVendedor from "./views/Reportes/GraficaVentasMensualVendedor";
import GraficaVentasDepartamento from "./views/Reportes/GraficaVentasDepartamento";
import GraficaVentasGrupo from "./views/Reportes/GraficaVentasGrupo";
import GraficaVentasVendedor from "./views/Reportes/GraficaVentasVendedor";
import GraficaVentasEstado from "./views/Reportes/GraficaVentasEstado";
import ReporteUltimoPrecio from "./views/Reportes/ReporteUltimoPrecio";
import ReporteUltimoPrecioArticulo from "./views/Reportes/ReporteUltimoPrecioArticulo";
import GraficaVentasMensualCliente from "./views/Reportes/GraficaVentasMensualCliente";
import ValorInventario from './views/Reportes/ValorInventario'
import ListadoSellThru from "./views/Reportes/ListadoSellThru";
import CalificadoraClientes from "./views/Reportes/CalificadoraClientes";
import BotonesReportesVentas from "./views/Reportes/BotonesReportesVentas";
import BotonesReportesAdmin from "./views/Reportes/BotonesReportesAdmin";
import GraficaVentasMensualComparativa from "./views/Reportes/GraficaVentasMensualComparativa";
import GraficaVentasDesgloce from "./views/Reportes/GraficaVentasDesgloce";
import ReporteResumenAbonosTiendas from "./views/Reportes/ReporteResumenAbonosTiendas";
import ReporteResumenVentasTiendas from "./views/Reportes/ReporteResumenVentasTiendas";
import TablaVentasMensualComparativa from "./views/Reportes/TablaVentasMensualComparativa";
import TablaAbonosMensualComparativa from "./views/Reportes/TablaAbonosMensualComparativa";
import TablaAbonosMensualComparativaAlmacen from "./views/Reportes/TablaAbonosMensualComparativaAlmacen.jsx";
import TablaVentasMensualComparativaCliente from "./views/Reportes/TablaVentasMensualComparativaCliente";
import TablaVentasMensualComparativaVendedor from "./views/Reportes/TablaVentasMensualComparativaVendedor";
import TablaVentasArticulos from "./views/Reportes/TablaVentasArticulos";

// Fiscal
import BotonesFiscal from "./views/Fiscal/BotonesFiscal";
import ListadoFacturas from "./views/Fiscal/Facturacion/ListadoFacturas.jsx";
import FacturasCreate from "./views/Fiscal/Facturacion/FacturasCreate.jsx";
import ListadoComplementosPago from "./views/Fiscal/ComplementosPago/ListadoComplementosPago.jsx";
import ComplementosPagoCreate from "./views/Fiscal/ComplementosPago/ComplementosPagoCreate.jsx";
import NotasCreditoCreate from "./views/Fiscal/NotasCredito/NotasCreditoCreate.jsx";
import ListadoNotasCredito from "./views/Fiscal/NotasCredito/ListadoNotasCredito.jsx";
import DevolucionesFiscalCreate from "./views/Fiscal/DevolucionesFiscal/DevolucionesFiscalCreate.jsx";
import ListadoDevolucionesFiscal from "./views/Fiscal/DevolucionesFiscal/ListadoDevolucionesFiscal.jsx";
import RegistrarEmpresas from "./views/Fiscal/RegistrarEmpresa/RegistrarEmpresas.jsx";
import ListadoEmpresas from "./views/Fiscal/Empresas/ListadoEmpresas.jsx";
import EmpresasCreate from "./views/Fiscal/Empresas/EmpresasCreate.jsx";


// Dashboards
import BotonesDashboards from "./views/Reportes/BotonesDashboards";
import DashboardVentas from "./views/Reportes/DashboardVentas";
import DashboardInventarios from "./views/Reportes/DashboardInventarios";
import Balance from "./views/Reportes/Balance";

// Logs
import Logs from './views/Logs/ListadoLogs'

// Monitoring
import Monitoring from "./views/Monitoring/Monitoring";

// Config
import Configuraciones from './views/Configuracion/Configuraciones'

// Admin
import BotonesAdmin from "./views/Admin/BotonesAdmin";
import ListadoBancos from "./views/Admin/Bancos/ListadoBancos";
import AnticiposCreate from './views/Admin/Anticipos/AnticiposCreate'
import ListadoAnticipos from './views/Admin/Anticipos/ListadoAnticipos'
import AbonosCreate from './views/Admin/Abonos/AbonosCreate'
import ListadoAbonos from './views/Admin/Abonos/ListadoAbonos'
import NotasCargoCreate from './views/Admin/NotasCargo/NotasCargoCreate'
import ListadoNotasCargo from './views/Admin/NotasCargo/ListadoNotasCargo'
import ListadoDevolucionesAdmin from './views/Admin/DevolucionesAdmin/ListadoDevolucionesAdmin'
import EstadoCuenta from "./views/Admin/EstadoCuenta/EstadoCuenta";
import ComisionesCreate from "./views/Admin/Comisiones/ComisionesCreate";
import ListadoComisiones from "./views/Admin/Comisiones/ListadoComisiones";
import EstadoCuentaColaboradores from "./views/Admin/Comisiones/EstadoCuentaColaboradores";
import ListadoVentas from "./views/Admin/Ventas/ListadoVentas";

// CXP
import BotonesCXP from "./views/CXP/BotonesCXP";
import EstadoCuentaCXP from "./views/CXP/EstadoCuentaCXP/EstadoCuentaCXP";
import ListadoComprasCXP from "./views/CXP/ComprasCXP/ListadoComprasCXP";
import AbonosProveedoresCreate from './views/CXP/AbonosProveedores/AbonosProveedoresCreate'
import ListadoAbonosProveedores from './views/CXP/AbonosProveedores/ListadoAbonosProveedores'

//Traspasos Dinero
import TraspasosDineroCreate from './views/Tiendas/TraspasosDinero/TraspasosDineroCreate'
import ListadoTraspasosDinero from './views/Tiendas/TraspasosDinero/ListadoTraspasosDinero'


//  Cadenas
import BotonesCadenas from "./views/Cadenas/BotonesCadenas"
import ListadoInsumos from "./views/Cadenas/Insumos/ListadoInsumos"
import InsumosCreate from "./views/Cadenas/Insumos/InsumosCreate";
import ListadoProveedoresMex from './views/Cadenas/ProveedoresMex/ListadoProveedoresMex'
import ProveedoresCreateMex from './views/Cadenas/ProveedoresMex/ProveedoresCreateMex'
import ListadoOrdenesCompraHab from './views/Cadenas/OrdenesCompraHab/ListadoOrdenesCompraHab'
import OrdenesCompraHabCreate from './views/Cadenas/OrdenesCompraHab/OrdenesCompraHabCreate'
import ListadoComprasHab from "./views/Cadenas/ComprasHab/ListadoComprasHab";
import ComprasHabCreate from "./views/Cadenas/ComprasHab/ComprasHabCreate";
import ListadoInventariosInsumos from "./views/Cadenas/Insumos/ListadoInventariosInsumos";
import ListadoCadenas from "./views/Cadenas/Cadenas/ListadoCadenas";
import ListadoPedidosCadenas from './views/Cadenas/Pedidos/ListadoPedidosCadenas'
import EstadoCuentaHab from "./views/Cadenas/EstadoCuentaHab/EstadoCuentaHab";
import AbonosProveedoresHabCreate from "./views/Cadenas/AbonosProveedoresHab/AbonosProveedoresHabCreate";
import ListadoAbonosProveedoresHab from "./views/Cadenas/AbonosProveedoresHab/ListadoAbonosProveedoresHab";


// Whastapp
import Whatsapp from "./views/WhatsApp/Whatsapp";
import ListadoClientesWhatsapp from "./views/VentasWhatsApp/ListadoClientesWhatsapp.jsx";
import ListadoPedidosWhatsapp from "./views/VentasWhatsApp/Pedidos/ListadoPedidosWhatsapp.jsx";

// Asistente IA
import AsistenteIAPage from "./views/AsistenteIA/AsistenteIAPage";

function AppRoutes() {
    return (
        <AuthContextProvider>
            <ChatContextProvider>
            <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Inicio" element={<Inicio />} />
                <Route path="/Login" element={<Login />} />
                <Route path="/provider-login" element={<ProviderLogin />} />
                <Route path="/Logout" element={<Logout />} />
                <Route path="/provider-dashboard" element={<ProviderRoute><ProviderDashboard /></ProviderRoute>} />
                <Route path="/china-label-generator" element={<ProviderRoute><GeneradorEtiquetasChina /></ProviderRoute>} />
                <Route path="/MenuUsuarios" element={<ListadoUsuarios />} />
                <Route path="/MenuUsuariosAdmin" element={<ListadoUsuariosAdmin />} />
                {/* Catalogos */}
                <Route path="/MenuCatalogos" element={<BotonesCatalogos />} />
                <Route path="/Areas" element={<ListadoAreas />} />
                <Route path="/Paqueterias" element={<ListadoPaqueterias />} />
                <Route path="/PeriodosAdmin" element={<ListadoPeriodosAdmin />} />
                <Route path="/PeriodosAdminCreate" element={<PeriodosAdminCreate />} />
                <Route path="/Ciclos" element={<ListadoCiclos />} />
                <Route path="/Cajas" element={<ListadoCajas />} />
                <Route path="/Departamentos" element={<ListadoDepartamentos />} />
                <Route path="/Proveedores" element={<ListadoProveedores />} />
                {/* Articulos */}
                <Route path="/MenuArticulos" element={<BotonesArticulos />} />
                <Route path="/Lineas" element={<ListadoLineas />} />
                <Route path="/Colores" element={<ListadoColores />} />
                <Route path="/Tallas" element={<ListadoTallas />} />
                <Route path="/Marcas" element={<ListadoMarcas />} />
                <Route path="/Familias" element={<ListadoFamilias />} />
                <Route path="/Colecciones" element={<ListadoColecciones />} />
                <Route path="/ListadoArticulos" element={<ListadoArticulos />} />
                <Route path="/ListadoArticulosFoto" element={<ListadoArticulosFoto />} />
                <Route path="/ArticulosCreate" element={<ArticulosCreate />} />
                <Route path="/ListadoPreArticulos" element={<ListadoPreArticulos />} />
                <Route path="/PreArticulosCreate" element={<PreArticulosCreate />} />
                <Route path="/ConvertirArticulos" element={<ConvertirArticulos />} />
                <Route path="/GeneradorEtiquetas" element={<GeneradorEtiquetas />} />
                <Route path="/ListadoPreArticulosChina" element={<ListadoPreArticulosChina />} />
                <Route path="/PreArticulosChinaCreate" element={<PreArticulosChinaCreate />} />
                <Route path="/GeneradorEtiquetasChina" element={<GeneradorEtiquetasChina />} />
                {/* Inventarios */}
                <Route path="/MenuInventarios" element={<BotonesInventarios />} />
                <Route path="/ListadoInventarios" element={<ListadoInventarios />} />
                <Route path="/ListadoDisponible" element={<ListadoDisponible />} />
                <Route path="/ListadoDisponibleVendedor" element={<ListadoDisponibleVendedor />} />
                <Route path="/ListadoInventarioPendRecibir" element={<ListadoInventarioPendRecibir />} />
                <Route path="/ListadoKardex" element={<ListadoKardex />} />
                <Route path="/ListadoTracking" element={<ListadoTracking />} />
                <Route path="/ListadoAjustesInventario" element={<ListadoAjustesInventario />} />
                <Route path="/AjustesInventarioCreate" element={<AjustesInventarioCreate />} />
                <Route path="/MenuTraspasos" element={<BotonesTraspasos />} />
                <Route path="/CuadrarInventario" element={<CuadrarInventario />} />
                {/* Tiendas */}
                <Route path="/MenuTiendas" element={<BotonesTiendas />} />
                <Route path="/ListadoInventariosTiendas" element={<ListadoInventariosTiendas />} />
                <Route path="/ListadoVentasTiendas" element={<ListadoVentasTiendas />} />
                <Route path="/ListadoVentasTiendasPendientes" element={<ListadoVentasTiendasPendientes />} />
                <Route path="/ListadoApartadosTiendas" element={<ListadoApartadosTiendas />} />
                <Route path="/VentasTiendasCreate" element={<VentasTiendasCreate />} />
                <Route path="/ApartadosTiendasCreate" element={<ApartadosTiendasCreate />} />
                <Route path="/AnticiposTiendas" element={<ListadoApartadosTiendas modo="anticipos" />} />
                <Route path="/AbonosTiendasCreate" element={<AbonosTiendasCreate />} />
                <Route path="/ListadoAbonosTiendas" element={<ListadoAbonosTiendas />} />
                <Route path="/GastosTiendas" element={<ListadoGastosTiendas />} />
                <Route path="/GastosTiendasCreate" element={<GastosTiendasCreate />} />
                <Route path="/DinerosTiendas" element={<ListadoDinerosTiendas />} />
                <Route path="/DinerosTiendasCreate" element={<DinerosTiendasCreate />} />
                <Route path="/ListadoDevolucionesTiendas" element={<ListadoDevolucionesTiendas />} />
                <Route path="/DevolucionesTiendasCreate" element={<DevolucionesTiendasCreate />} />
                <Route path="/CorteTiendas" element={<CorteTiendas />} />
                <Route path="/CorteTiendasK" element={<CorteTiendasK />} />
                <Route path="/EntregarNota" element={<EntregarNota />} />
                <Route path="/EstadoCuentaTiendas" element={<EstadoCuentaTiendas />} />
                <Route path="/EstadoCuentaTiendasAnalisis" element={<EstadoCuentaTiendasAnalisis />} />
                <Route path="/ListadoDevolucionesTiendasAdmin" element={<ListadoDevolucionesTiendasAdmin />} />
                <Route path="/ListadoClientesTiendas" element={<ListadoClientesTiendas />} />
                <Route path="/ClientesCreateTiendas" element={<ClientesCreateTiendas />} />
                <Route path="/FacturasTiendasCreate/:idVenta" element={<FacturasTiendasCreate />} />
                <Route path="/FacturasTiendasCreate" element={<FacturasTiendasCreate />} />
                <Route path="/EscaneoTiendas" element={<Escaneos />} />
                <Route path="/ListadoEscaneos" element={<ListadoEscaneos />} />

                {/* Traspasos */}
                <Route path="/TraspasosSalidaCreate" element={<TraspasosSalidaCreate />} />
                <Route path="/ListadoTraspasosSalida" element={<ListadoTraspasosSalida />} />
                <Route path="/TraspasosEntradaCreate" element={<TraspasosEntradaCreate />} />
                <Route path="/ListadoTraspasosEntrada" element={<ListadoTraspasosEntrada />} />
                {/* Compras */}
                <Route path="/MenuCompras" element={<BotonesCompras />} />
                <Route path="/ListadoOrdenesCompra" element={<ListadoOrdenesCompra />} />
                <Route path="/OrdenesCompraCreate" element={<OrdenesCompraCreate />} />
                <Route path="/ListadoEmbarques" element={<ListadoEmbarques />} />
                <Route path="/EmbarquesCreate" element={<EmbarquesCreate />} />
                <Route path="/ListadoPendEmbarcar" element={<ListadoPendEmbarcar />} />
                <Route path="/ListadoCompras" element={<ListadoCompras />} />
                <Route path="/ComprasCreate" element={<ComprasCreate />} />
                <Route path="/EntradasPreModelos" element={<EntradasPreModelos />} />
                <Route path="/ListadoPendRecibir" element={<ListadoPendRecibir />} />
                <Route path="/ConceptosGastosEmbarques" element={<ListadoConceptosGastosEmbarques />} />
                <Route path="/ListadoControlCalidad" element={<ListadoControlCalidad />} />
                {/* Ventas */}
                <Route path="/MenuVentas" element={<BotonesVentas />} />
                <Route path="/ListadoPedidos" element={<ListadoPedidos />} />
                <Route path="/VistaPedido/:idPedido" element={<VistaPedido />} />
                <Route path="/PedidosCreate" element={<PedidosCreate />} />
                <Route path="/ListadoSurtidos" element={<ListadoSurtidos />} />
                <Route path="/ListadoPendienteSurtir" element={<ListadoPendienteSurtir />} />
                <Route path="/ListadoDevoluciones" element={<ListadoDevoluciones />} />
                <Route path="/DevolucionesCreate" element={<DevolucionesCreate />} />
                <Route path="/DepartamentosClientes" element={<ListadoDepartamentosClientes />} />
                <Route path="/AnalisisArticulosPedidos" element={<AnalisisArticulosPedidos />} />
                <Route path="/ListoSurtir" element={<ListoSurtir />} />
                <Route path="/ListoSurtirCliente" element={<ListoSurtirCliente />} />
                {/* Gastos */}
                <Route path="/MenuGastos" element={<BotonesGastos />} />
                <Route path="/Presupuestos" element={<ListadoPresupuestos />} />
                <Route path="/PresupuestosCreate" element={<PresupuestosCreate />} />
                <Route path="/MenuNominas" element={<BotonesNominas />} />
                <Route path="/Nominas" element={<ListadoNominas />} />
                <Route path="/Empleados" element={<ListadoColaboradores />} />
                <Route path="/EmpleadosCreate" element={<ColaboradoresCreate />} />
                <Route path="/FaltasColaboradores" element={<ListadoFaltasColaboradores />} />
                <Route path="/FaltasColaboradoresCreate" element={<FaltasColaboradoresCreate />} />
                <Route path="/NominasCreate" element={<NominasCreate />} />
                <Route path="/Puestos" element={<ListadoPuestos />} />
                {/* <Route path="/Gastos" element={<ListadoGastos />} />
                <Route path="/GastosCreate" element={<GastosCreate />} /> */}
                <Route path="/ProveedoresCreate" element={<ProveedoresCreate />} />
                <Route path="/Gastos" element={<ListadoGastosGeneral />} />
                <Route path="/GastosCreate" element={<GastosGeneralCreate />} />
                <Route path="/ConceptosGastos" element={<ListadoConceptosGastos />} />
                <Route path="/conceptosGastosCreate" element={<ConceptosGastosCreate />} />
                {/* Clientes */}
                <Route path="/Clientes" element={<ListadoClientes />} />
                <Route path="/ClientesCreate" element={<ClientesCreate />} />
                <Route path="/Grupos" element={<ListadoGrupos />} />
                {/* Reportes */}
                <Route path="/MenuReportes" element={<BotonesReportes />} />
                <Route path="/MenuReportesV2" element={<BotonesReportesV2 />} />
                <Route path="/MenuReportesAdmin" element={<BotonesReportesAdmin />} />
                <Route path="/MenuReportesVentas" element={<BotonesReportesVentas />} />
                <Route path="/GraficaVentasMensualComparativa" element={<GraficaVentasMensualComparativa />} />
                <Route path="/TablaVentasArticulos" element={<TablaVentasArticulos />} />
                <Route path="/TablaVentasMensualComparativa" element={<TablaVentasMensualComparativa />} />
                <Route path="/TablaAbonosMensualComparativa" element={<TablaAbonosMensualComparativa />} />
                <Route path="/TablaAbonosMensualComparativaAlmacen" element={<TablaAbonosMensualComparativaAlmacen />} />
                <Route path="/TablaVentasMensualComparativaCliente" element={<TablaVentasMensualComparativaCliente />} />
                <Route path="/TablaVentasMensualComparativaVendedor" element={<TablaVentasMensualComparativaVendedor />} />
                <Route path="/GraficaVentasMensualCliente" element={<GraficaVentasMensualCliente />} />
                <Route path="/GraficaVentasMensualVendedor" element={<GraficaVentasMensualVendedor />} />
                <Route path="/GraficaVentasDesgloce" element={<GraficaVentasDesgloce />} />
                <Route path="/GraficaVentasDepartamento" element={<GraficaVentasDepartamento />} />
                <Route path="/GraficaVentasGrupo" element={<GraficaVentasGrupo />} />
                <Route path="/GraficaVentasVendedor" element={<GraficaVentasVendedor />} />
                <Route path="/GraficaVentasEstado" element={<GraficaVentasEstado />} />
                <Route path="/ReporteUltimoPrecio" element={<ReporteUltimoPrecio />} />
                <Route path="/ReporteUltimoPrecioArticulo" element={<ReporteUltimoPrecioArticulo />} />
                <Route path="/ValorInventario" element={<ValorInventario />} />
                <Route path="/SellThru" element={<ListadoSellThru />} />
                <Route path="/CalificadoraClientes" element={<CalificadoraClientes />} />
                <Route path="/ReporteResumenAbonosTiendas" element={<ReporteResumenAbonosTiendas />} />
                <Route path="/ReporteResumenVentasTiendas" element={<ReporteResumenVentasTiendas />} />

                {/* Fiscal */}
                <Route path="/MenuFiscal" element={<BotonesFiscal />} />
                <Route path="/ListadoFacturas" element={<ListadoFacturas />} />
                <Route path="/FacturasCreate" element={<FacturasCreate />} />
                <Route path="/ListadoComplementosPago" element={<ListadoComplementosPago />} />
                <Route path="/ComplementosPagoCreate" element={<ComplementosPagoCreate />} />
                <Route path="/ListadoNotasCredito" element={<ListadoNotasCredito />} />
                <Route path="/NotasCreditoCreate" element={<NotasCreditoCreate />} />
                <Route path="/ListadoDevolucionesFiscal" element={<ListadoDevolucionesFiscal />} />
                <Route path="/DevolucionesFiscalCreate" element={<DevolucionesFiscalCreate />} />
                <Route path="/RegistrarEmpresas" element={<RegistrarEmpresas />} />
                <Route path="/ListadoEmpresas" element={<ListadoEmpresas />} />
                <Route path="/EmpresasCreate" element={<EmpresasCreate />} />

                {/* Dashboards */}
                <Route path="/Dashboards" element={<BotonesDashboards />} />
                <Route path="/DashboardVentas" element={<DashboardVentas />} />
                <Route path="/DashboardInventarios" element={<DashboardInventarios />} />
                <Route path="/Balance" element={<Balance />} />

                {/* Logs  */}
                <Route path="/MenuLogs" element={<Logs />} />
                {/* Monitoring  */}
                <Route path="/Monitoring" element={<Monitoring />} />
                {/* Config  */}
                <Route path="/MenuConfiguraciones" element={<Configuraciones />} />
                {/* Admin */}
                <Route path="/MenuAdmin" element={<BotonesAdmin />} />
                <Route path="/Bancos" element={<ListadoBancos />} />
                <Route path="/AnticiposCreate" element={<AnticiposCreate />} />
                <Route path="/ListadoAnticipos" element={<ListadoAnticipos />} />
                <Route path="/AbonosCreate" element={<AbonosCreate />} />
                <Route path="/ListadoAbonos" element={<ListadoAbonos />} />
                <Route path="/NotasCargoCreate" element={<NotasCargoCreate />} />
                <Route path="/ListadoNotasCargo" element={<ListadoNotasCargo />} />
                <Route path="/ListadoDevolucionesAdmin" element={<ListadoDevolucionesAdmin />} />
                <Route path="/EstadoCuenta" element={<EstadoCuenta />} />
                <Route path="/ComisionesCreate" element={<ComisionesCreate />} />
                <Route path="/ListadoComisiones" element={<ListadoComisiones />} />
                <Route path="/ListadoVentas" element={<ListadoVentas />} />
                <Route path="/EstadoCuentaVendedores" element={<EstadoCuentaColaboradores />} />
                {/* CXP */}
                <Route path="/MenuCXP" element={<BotonesCXP />} />
                <Route path="/EstadoCuentaCXP" element={<EstadoCuentaCXP />} />
                <Route path="/ListadoComprasCXP" element={<ListadoComprasCXP />} />
                <Route path="/AbonosProveedoresCreate" element={<AbonosProveedoresCreate />} />
                <Route path="/ListadoAbonosProveedores" element={<ListadoAbonosProveedores />} />
                {/* Traspasos Dinero */}
                <Route path="/TraspasosDineroCreate" element={<TraspasosDineroCreate />} />
                <Route path="/ListadoTraspasosDinero" element={<ListadoTraspasosDinero />} />
                {/* Cadenas */}
                <Route path="/MenuCadenas" element={<BotonesCadenas />} />
                <Route path="/ListadoInsumos" element={<ListadoInsumos />} />
                <Route path="/InsumosCreate" element={<InsumosCreate />} />
                <Route path="/ProveedoresMex" element={<ListadoProveedoresMex />} />
                <Route path="/ProveedoresCreateMex" element={<ProveedoresCreateMex />} />
                <Route path="/ListadoOrdenesCompraHab" element={<ListadoOrdenesCompraHab />} />
                <Route path="/OrdenesCompraHabCreate" element={<OrdenesCompraHabCreate />} />
                <Route path="/ListadoComprasHab" element={<ListadoComprasHab />} />
                <Route path="/ComprasHabCreate" element={<ComprasHabCreate />} />
                <Route path="/ListadoInventariosInsumos" element={<ListadoInventariosInsumos />} />
                <Route path="/ListadoCadenas" element={<ListadoCadenas />} />
                <Route path="/ListadoPedidosCadenas" element={<ListadoPedidosCadenas />} />
                <Route path="/EstadoCuentaHab" element={<EstadoCuentaHab />} />
                <Route path="/AbonosProveedoresHabCreate" element={<AbonosProveedoresHabCreate />} />
                <Route path="/ListadoAbonosProveedoresHab" element={<ListadoAbonosProveedoresHab />} />
                {/* Whatsapp */}
                <Route path="/Whatsapp" element={<Whatsapp />} />
                <Route path="/ClientesWhatsapp" element={<ListadoClientesWhatsapp />} />
                <Route path="/ListadoPedidosWhatsapp" element={<ListadoPedidosWhatsapp />} />
                {/* Asistente IA */}
                <Route path="/AsistenteIA" element={<AsistenteIAPage />} />
            </Routes>

            <ChatWidget />
            </BrowserRouter>
            </ChatContextProvider>
            </AuthContextProvider>

    )
}

export default AppRoutes
